import type {
  Components,
  InputComponent,
} from '@n3/react-autocomplete';

import {
  StyledInput,
} from '../../Input';

import { Menu } from './Menu';
import { MenuItem } from './MenuItem';

export const components: Partial<Components> = {
  Input: StyledInput as InputComponent,
  Menu,
  MenuItem,
};
